<template>
  <div>
    <el-dialog
      :title="`Tải lên ${typeFile}`"
      :visible.sync="dialogVisible"
      width="30%"
      :before-close="handleClose"
    >
      <div class="upload">
        <label for="upload-hd">
          <div class="upload-icon">
            <i :class="iconUpload"></i>
          </div>
          <div class="upload-text">{{ textStatus }}</div>
        </label>
        <input
          type="file"
          id="upload-hd"
          multiple
          accept=".jpg, .png, .jpeg, .pdf"
          @change="fn_upload"
          @click="fn_onInputClick"
          :disabled="disabledUpload"
        />
        <div class="footer">
          <div
            class="footer__info"
            v-if="isUploadSuccess && nameFiles.length > 0"
          >
            <p v-for="item in nameFiles" :key="item.id">
              <i class="fa-solid fa-circle-check"></i>&nbsp;<span
                :title="item"
                >{{ item }}</span
              >
            </p>
          </div>
        </div>
        <el-button
          type="success"
          @click="fn_accept()"
          :disabled="disabledAccept"
          >Xác nhận</el-button
        >
      </div>
    </el-dialog>
  </div>
</template>
<script>
import mushroom from "viettoc-api";
import MethodService from "@/service/MethodService";
export default {
  props: {
    typeFile: String,
    srcString: String,
    fieldString: String,
    ownerIdString: String,
  },
  data() {
    return {
      dialogVisible: true,
      disabledUpload: false,
      disabledAccept: true,
      listFileIDs: [],
      isUploadSuccess: false,
      nameFiles: [],
      textStatus: `Bấm chọn ${this.typeFile}`,
      iconUpload: "el-icon-upload el-icon-right",
    };
  },
  methods: {
    handleClose() {
      this.$emit("close-dialog");
    },
    fn_accept() {
      this.$emit("accept-list-files", this.nameFiles);
    },
    async fn_upload(event) {
      this.textStatus = "Đang tải";
      this.iconUpload = "fa-regular fa-spinner loading-icon";
      this.disabledUpload = true;
      this.disabledAccept = true;
      this.listFileIDs = [];
      try {
        const fileImage = event.target.files;
        if (fileImage && fileImage.length > 0) {
          let arrayPromise = [];
          for (const file_item of fileImage) {
            let typeImage = file_item.name.slice(file_item.name.indexOf("."));
            if (
              typeImage != ".jpg" &&
              typeImage != ".png" &&
              typeImage != ".jpeg" &&
              typeImage != ".pdf"
            ) {
              window.toastr.warning(`Định dạng ${typeFile} là ảnh hoặc pdf`);
            } else {
              this.nameFiles.push(file_item.name);
              const res = mushroom.$file.uploadAsync({
                file: file_item,
                tags: [
                  `src:${this.srcString}, field:${this.fieldString}, owner_id:${this.ownerIdString}`,
                ],
              });
              arrayPromise.push(res);
            }
          }
          Promise.all(arrayPromise).then((list_data) => {
            list_data.forEach((item) => {
              this.listFileIDs.push(item.result);
            });
            this.$forceUpdate();
            this.disabledAccept = false;
            this.disabledUpload = false;
            this.$emit("list-files-ids", this.listFileIDs);
            this.isUploadSuccess = true;
            this.textStatus = `Bấm chọn ${this.typeFile}`;
            this.iconUpload = "el-icon-upload el-icon-right";
          });
        }
      } catch (e) {
        MethodService.showError(e.code);
        this.textStatus = `Bấm chọn ${this.typeFile}`;
        this.iconUpload = "el-icon-upload el-icon-right";
        this.disabledUpload = false;
      }
    },
    fn_onInputClick(event) {
      event.target.value = "";
    },
  },
  watch: {
    isAddAgentSuccess: function () {
      this.dialogVisible = this.isAddAgentSuccess;
      this.isUploadSuccess = false;
      this.disabledAccept = true;
      this.nameFiles = [];
    },
  },
};
</script>
<style scoped lang="scss">
.upload {
  text-align: center;
  position: relative;
  button {
    margin-top: 5px;
  }
}
.upload-icon {
  border-right: thin solid #dcdcdc;
  i {
    margin-right: 8px;
  }
}
.upload-text {
  width: calc(100% - 25px);
  text-align: center;
}
.upload label {
  border: thin solid #dcdcdc;
  padding: 5px 10px;
  border-radius: 5px;
  color: #409eff;
  cursor: pointer;
  display: flex;
  width: 260px;
  margin: 10px auto 10px;
}

#upload-hd {
  display: none;
}
.alert-upload {
  color: #67c23a;
  margin: 0 0 10px;
  position: absolute;
  top: -25px;
  right: 0;
  i {
    margin-right: 5px;
  }
}
.footer {
  display: flex;
  margin: auto;
  &__info {
    top: -5px;
    font-size: 13px;
    max-width: 200px;
    margin: auto;
  }
  &__info i {
    color: #67c23a;
  }
  &__info p {
    text-align: left;
    display: block;
    display: -webkit-box;
    -webkit-line-clamp: 1;
    -webkit-box-orient: vertical;
    overflow: hidden;
    text-overflow: ellipsis;
  }
  &__info span {
    color: #857f7f;
  }
  button {
    position: absolute;
    top: 18px;
    width: 100%;
  }
}
</style>
